<template>
  <div class="gewerbestep5">

    <div class="ueber primary--text mb-6">Rechtliche Hinweise und Angaben</div>


    <div>
      <v-checkbox v-model="invitatio"
                  v-validate="'required'"
                  data-vv-as="Vorlage der Unterlagen"
                  data-vv-name="invitatio"
                  :error="isInvitatio ? true : false"
                  :error-messages="isInvitatio ? 'Die Vorlage der Kundeninformationen und der weiternen aufgeführten Dokumente muss bestätigt werden.' : ''"
                  :hide-details="false"
                  name="invitatio"
                  type="checkbox"
                  label="Die Kundeninformationen inklusive Allgemeine Vertragsinformationen, Wichtige Anzeigepflichten gemäß § 19 Absatz 5 VVG, Merkblatt zur Datenverarbeitung, Allgemeine Bedingungen für die Rechtsschutz-Versicherung (ARB 2026), Klauseln und Sonderbedingungen und die Allgemeinen Tarifbestimmungen lagen dem Kunden/der bevollmächtigten Person vor."
                  value="N"
                  class="no-max-width"
                  color="primary" />
    </div>

    <div class="my-4 primary--text subueber">Datenschutzhinweise</div>

    <div class="dmb-form-text">
      <div class="pb-4">
        Mit der Abgabe des Deckungsauftrags werden personenbezogene Daten des Kunden erhoben, die sich aus dem Formular ergeben. Die von Ihnen zur Verfügung gestellten personenbezogenen Daten werden von der DMB Rechtsschutz nur nach den gesetzlichen Vorgaben (insbesondere Bundesdatenschutzgesetz „BDSG“ und Datenschutz-Grundverordnung „DSGVO“) erhoben und verarbeitet. Die DMB Rechtsschutz und ihr Datenschutzbeauftragter sind die verantwortliche Stelle für die Erhebung, Verarbeitung und Nutzung der personenbezogenen Daten.<br> Der Datenschutzbeauftragte der DMB Rechtsschutz ist erreichbar unter: DMB Rechtsschutz-Versicherung AG, Bonner Str. 323, 50968 Köln, per E-Mail: <a href="mailto:datenschutz@dmb-rechtsschutz.de">datenschutz@dmb-rechtsschutz.de</a>.
      </div>
      <div class="pb-4">
        Die DMB Rechtsschutz verarbeitet und speichert die personenbezogenen Daten nur im Rahmen der Zweckbestimmung des Versicherungsvertrages gemäß Art. 6 Absatz 1 b) DSGVO. Empfänger der personenbezogenen Daten können für die Beurteilung des Versicherungsrisikos und zur Abwicklung etwaiger Rückversicherungen andere Versicherer und/oder der Gesamtverband der Deutschen Versicherungswirtschaft e.V. sein. Die personenbezogenen Daten werden nur für den Umfang und die Zeit, für die die Speicherung im Sinne des Art. 17 Absatz 1 a) DSGVO notwendig ist und die DMB Rechtsschutz ihre eigenen gesetzlichen Verpflichtungen zu erfüllen hat, gespeichert. Jede betroffene Person hat gegenüber der DMB Rechtsschutz das Recht auf Auskunft nach Art. 15 DSGVO, das Recht auf Berichtigung nach Art. 16 DSGVO, das Recht auf Löschung nach Art. 17 DSGVO, das Recht auf Einschränkung der Verarbeitung nach Art. 18 DSGVO sowie das Recht auf Datenübertragbarkeit nach Art. 20 DSGVO.
      </div>
    </div>

    <div class="my-4 primary--text subueber">Bonitätsprüfung</div>

    <div class="dmb-form-text">
      <div class="pb-4">
        Wir übermitteln die Daten des Kunden (Name, Adresse und ggf. Geburtsdatum) zur Beurteilung des Zahlungsausfallrisikos auf Basis mathematisch-statistischer Verfahren unter Verwendung von Anschriftendaten (Bonitätsprüfung) an die infoscore Consumer Data GmbH, Rheinstraße 99, 76532 Baden-Baden bzw. die Creditreform Köln, Gustav-Heinemann-Ufer 68, 50968 Köln. Rechtsgrundlagen dieser Übermittlung sind die Art. 6 Absatz 1 b) und Art. 6 Absatz 1 f) DSGVO. Übermittlungen auf der Grundlage dieser Bestimmungen dürfen nur erfolgen, soweit dies zur Wahrnehmung berechtigter Interessen unseres Unternehmens oder Dritter erforderlich ist und nicht die Interessen der Grundrechte und Grundfreiheiten der betroffenen Person, die den Schutz personenbezogener Daten erfordern, überwiegen.
      </div>
    </div>

    <div class="my-4 primary--text subueber">Einwilligung zu Werbezwecken</div>

    <div class="dmb-form-text">
      <div class="pb-4">
        Wir möchten den Kunden künftig im Rahmen des Versicherungsverhältnisses über weitere Leistungen der DMB Rechtsschutz schriftlich, mündlich, telefonisch oder über andere elektronische Kommunikationsmittel (z. B. Telefax, E-Mail) informieren und beraten. Hierzu bitten wir Sie, uns die Einwilligung für die Nutzung der Kundendaten zu erteilen. Eine einmalig erteilte Einwilligung kann jederzeit für die Zukunft widerrufen werden. Die Abgabe bzw. der Widerruf der Einwilligung hat keinen Einfluss auf den Abschluss des Versicherungsvertrages. Der Widerruf ist zu richten an DMB Rechtsschutz-Versicherung AG, Bonner Straße 323, 50968 Köln, per E-Mail an: <a href="mailto:kundenservice@dmb-rechtsschutz.de">kundenservice@dmb-rechtsschutz.de</a>.<br>
      </div>
    </div>

    <div>
      <v-checkbox v-model="werbezwecke"
                  hide-details
                  name="werbezwecke"
                  type="checkbox"
                  label="Einwilligung zu Werbezwecken erteilen"
                  value="J"
                  color="primary" />
    </div>

    <v-row no-gutters
           class="stepperbuttons">
      <v-btn color="primary"
             class="standard-button"
             @click="step5Back">Zurück
      </v-btn>
      <v-spacer />
      <v-btn color="primary"
             class="standard-button"
             @click="$emit('angebot')">
        Angebot erstellen
      </v-btn>
      <v-btn color="primary"
             class="standard-button ml-6"
             @click="antragEinreichen">Antrag einreichen
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import twowayBindingMixin from '../../store/twowayBindingMixin';
import ValidationMixin from '../helper/ValidationMixin';
import {mapTwoWay} from '../../store/twowayBindingMixin';

export default {
  name: "GewerbeStep5",
  mixins: [ twowayBindingMixin, ValidationMixin ],
  computed: {
    ...mapTwoWay([
      'werbezwecke',
      'invitatio',
      'invitatioValidation'
    ], {}, 'gewerbe.vertrag'),
    isInvitatio(){
      //this is needed becausec veevalidate does not handle the display of checkbox validation errors 
      return (this.invitatio != 'N') && (this.invitatioValidation) ? true : false;
    }
  },
  methods: {
    antragEinreichen(){
      this.invitatioValidation = true;
      this.$emit('step-forward');
    },
    step5Back(){
      this.invitatioValidation = false;
      this.$emit('step-back');
    }
  }
};
</script>
<style>
.stepperbuttons .standard-button.ml-6 {
  margin: 0 0 0 24px!important;
}
</style>
